<script>
  export let visible;

  import OutlookEmails from "../components/dashboard/outlook/OutlookEmails.svelte";
  import OutlookCalendar from "../components/dashboard/outlook/OutlookCalendar.svelte";
  import PicOfTheDay from "../modules/tools/screens/components/PicOfTheDay.svelte";
  import WeatherBox from "../modules/tools/screens/components/WeatherBox.svelte";
  import AllPeopleTasks from "../modules/pdashboard/screens/components/AllPeopleTasks.svelte";
  import WebBrowser from  "../components/WebBrowser.svelte";
  import MonthlyCalendar from "../modules/calendar/screens/components/MonthlyCalendar.svelte";
  //import Loading from "../components/Loading.svelte";
  //import { getAllProjects } from "../js/projects";
  import { getOutlookEmail, getPlatform } from "../js/localInfo";
  //import { onMount } from "svelte";
  import {
    getAllMyTasks,
    getAllMyPersonalTasks,
    //outlookLogin,
    outlookLoginSilent2
  } from "../components/dashboard/outlook/outlook.js";

  import DashboardBirthdays from "../components/dashboard/DashboardBirthdays.svelte";
  import TasksBox from "../modules/pdashboard/screens/components/TasksBox.svelte";

  import CompleteResourcePlanner from "../components/CompleteResourcePlanner/CompleteResourcePlanner.svelte";

  const platform = getPlatform();
  
  let toolURL = "";
  let showTool = "";
  let showNavMenu = null;  

  let closeTool = () => {
    showTool = "";
  };

  let clickTool = (url, forceNewWindow) => {
    toolURL = url;
    console.log(toolURL);
    if (platform === "Web") {
      openNewWindow(toolURL);
    } else {
      if (forceNewWindow) {
        openNewWindow(toolURL);
      } else {
        showTool = toolURL;
      }
    }
  };

  

  //const PAGE = "DASHBOARD";

  //let myId = getUserId();

  let tasksObj = {todo:[],inProgress:[],done:[]};
  let personalTasksObj = {todo:[],inProgress:[],done:[],link:""};
  
  const userName = getOutlookEmail();
  const promiseGetAllMyTasks = getAllMyTasks();
  const promiseGetAllMyPersonalTasks = getAllMyPersonalTasks(userName);

  (async () => {
    tasksObj = await promiseGetAllMyTasks;
    personalTasksObj = await promiseGetAllMyPersonalTasks;
  })();

</script>

<div class="content">
  <!-- Body -->
  <div class="container">
    <div class="dashboardItem">
      <WeatherBox />
    </div>
    <div class="dashboardItem">
      <MonthlyCalendar id="calendarDashboard" dashboard={true} />
    </div>
    <div class="dashboardItem">
      <OutlookEmails {visible} />
    </div>
    <div class="dashboardItem">
      <OutlookCalendar {visible} isGeneralEvent={false} />
    </div>
    <div class="dashboardItem">
      <DashboardBirthdays />
    </div>
    <div class="dashboardItem">
      <PicOfTheDay {visible} />
    </div>
    
    <div class="dashboardItem doubleWidget" on:click={() => clickTool("https://tasks.office.com/labit.es/es-ES/Home/Planner/#/planhub", false)}>
          <AllPeopleTasks
            id="myProjectsProgressChart"
            boxTitle={"My Projects Progress"}
            nTodo={tasksObj.todo.length}
            nInProgress={tasksObj.inProgress.length}
            nDone={tasksObj.done.length}
          />
    </div>
  
    <div class="dashboardItem">
      <TasksBox
        boxTitle={"My Projects Tasks"}
        taskList={tasksObj.todo}
        onChange={() => {
          //doneAllMyTasksPlanMyName = [];
          //inProgressAllMyTasksPlanMyName = [];
          //toDoAllMyTasksPlanMyName = [];
          //getTasksPlanMyName();
        }}
      />
    </div>
    
    <div class="dashboardItem doubleWidget" on:click={() => clickTool(personalTasksObj.link, false)}>      
      <AllPeopleTasks
        id="myPersonalProgressChart"
        boxTitle={"My Personal Progress"}
        nTodo={personalTasksObj.todo.length}
        nInProgress={personalTasksObj.inProgress.length}
        nDone={personalTasksObj.done.length}
      />
      
    </div>

    <div class="dashboardItem">
      <TasksBox
        boxTitle={"My Personal Tasks"}
        taskList={personalTasksObj.todo}
        onChange={() => {
          //doneAllMyTasksPlanMyName = [];
          //inProgressAllMyTasksPlanMyName = [];
          //toDoAllMyTasksPlanMyName = [];
          //getTasksPlanMyName();
        }}
      />
    </div>
  </div>
  
  <div class="tool {showTool !== '' ? '' : 'hiddenElement'}">
    <div class="toolOptions">
      <img
        class="fadedButton"
        src="/images/x.svg"
        alt="Close Tool"
        on:click={() => closeTool()}
      />
    </div>
    <div class="toolWebview">
      <WebBrowser
        id="pdToolWebview"
        type="webview"
        iframeTitle="External Tool"
        src={showTool}
        bind:showMenu={showNavMenu}
      />
    </div>
  </div>

  <div class="projects">
    <CompleteResourcePlanner editable={false} personal={true} />
  </div>
</div>

<style>
  div.content {
    width: 1640px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: auto;
    min-height: 100%;
  }

  div.container {
    width: 100%;
    display: flex;
    /*justify-content: flex-start;*/
    margin-top: 20px;
    flex-wrap: wrap;
    /*     display: grid; */
    grid-template-columns: auto auto auto auto auto auto;
    justify-content: space-between;
  }

  div.projects {
    width: 100%;
    display: flex;
    /*margin: 20px 0px 20px 0px;*/
    margin-bottom: 20px;
    flex-direction: column;
    background-color: white;
    border-radius: 14px;
    padding-bottom: 20px;
    margin-top: 30px;
    height: 800px;
  }

  div.dashboardItem {
    width: 260px;
    height: 300px;
    background-color: #ffff;
    border-radius: 14px;
    /*margin-right: 16px;*/
    margin-bottom: 16px;
  }

  div.doubleWidget {
    width: 535px !important;
    display: flex;
    align-items: center;
  }
  .tool {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .toolWebview {
    width: 100%;
    height: 800px;
  }

  .toolOptions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .toolOptions img {
    width: 10px;
  }
</style>
